import { create } from "zustand";

const useDetectionDetailsStore = create((set) => ({
  listDetections: [],
  detectionDetailsModal: false,
  modalContent: null,

  setListDetections: (detections) =>
    set((state) => ({
      listDetections:
        typeof detections === "function"
          ? detections(state.listDetections)
          : detections,
    })),

  setModalContent: (details) => set({ modalContent: details }),

  openDetailsModal: (poleId, imageArray, index = 0, pointDetails, onDelete = null) =>
    set(() => ({
      listDetections: imageArray,
      modalContent: {
        header: `Ponto de detecção n° ${poleId}`,
        imageArray,
        index,
        pointDetails,
        onDelete
      },
      detectionDetailsModal: true,
    })),

  closeDetailsModal: () =>
    set(() => ({
      detectionDetailsModal: false,
    })),
}));

export default useDetectionDetailsStore;
